import React from "react";
import TaggedOutbound from "@/components/TaggedOutbound";
import { dharmaApp } from "@/data/app";

// The two store links, tagged and counted as `app_store_click` like every other
// storefront link on the site. `tone="dark"` is for use on the indigo band.
// On a phone they sit side by side as two equal buttons, 48px tall.
export default function AppStoreButtons({ placement, tone = "light", className = "" }) {
  const shape = "min-h-[48px] justify-center whitespace-nowrap !px-4 sm:!px-[1.4rem]";
  const outline =
    tone === "dark"
      ? "btn-pill !border-dawn-rose/60 !text-cream hover:!bg-dawn-rose hover:!text-shrine-shadow hover:!border-dawn-rose"
      : "btn-pill";
  const solid =
    tone === "dark"
      ? "btn-pill !bg-cream !text-shrine-shadow !border-cream hover:!bg-dawn-rose hover:!border-dawn-rose"
      : "btn-pill btn-pill-solid";
  return (
    <div
      className={`grid grid-cols-2 gap-3 max-w-[400px] sm:flex sm:flex-wrap sm:items-center sm:max-w-none ${className}`}
    >
      <TaggedOutbound
        url={dharmaApp.stores.ios}
        event="app_store_click"
        store="app_store"
        titleId="dharma-app"
        slug="dharma-app"
        campaign={`app-${placement}`}
        className={`${solid} ${shape}`}
        showIcon={false}
      >
        App Store
      </TaggedOutbound>
      <TaggedOutbound
        url={dharmaApp.stores.android}
        event="app_store_click"
        store="google_play"
        titleId="dharma-app"
        slug="dharma-app"
        campaign={`app-${placement}`}
        className={`${outline} ${shape}`}
        showIcon={false}
      >
        Google Play
      </TaggedOutbound>
    </div>
  );
}
